"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Geolocation {
    constructor() {
        /**
         * @property positionResult: Object wrapping browser implementation to get Geolocation values
         */
        this.positionResult = {};
        /**
         * @property positionWatcher: Object Id to wathc the position change of the Geolocation API
         */
        this.positionWatcher = null;
        try {
            this.navigator = navigator.geolocation;
        }
        catch (error) {
            throw ({
                error,
            });
        }
    }
    /**
     * @property coordinates: Coordinates (latitude, Longitude) after retriving
     * the currentPosition or refresh by watchPosition
     * @returns IShortCoord
     */
    get coordinates() {
        try {
            const { coords: { latitude, longitude } } = this.positionResult;
            return {
                latitude,
                longitude,
            };
        }
        catch (error) {
            return error;
        }
    }
    /**
     * @property spped: Spped after retriving
     * the currentPosition or refresh by watchPosition
     * @returns number
     */
    get speed() {
        try {
            const { coords: { speed } } = this.positionResult;
            return speed;
        }
        catch (error) {
            return error;
        }
    }
    /**
     * @property heading: Direction of the Vehicle after retriving
     * the currentPosition or refresh by watchPosition
     * @returns number
     */
    get heading() {
        try {
            const { coords: { heading } } = this.positionResult;
            return heading;
        }
        catch (error) {
            return error;
        }
    }
    /**
     * @property operationTime: Time of when the position was required
     * @returns number
     */
    get operationTime() {
        try {
            const { timestamp } = this.positionResult;
            return timestamp;
        }
        catch (error) {
            return error;
        }
    }
    /**
     * @function currentPosition: Return current psoition of the Vehicle
     * @returns void
     */
    currentPosition(callback) {
        try {
            this.navigator.getCurrentPosition((result) => {
                this.position(result);
                callback();
            }, this.error, {});
        }
        catch (e) {
            this.error(e);
        }
    }
    /**
     * @function watchPosition: Will be changing the properties of the vehicle the vehicle moves
     * @returns void
     */
    watchPosition(callback) {
        try {
            this.positionWatcher = this.navigator.watchPosition((result) => {
                this.position(result);
                callback();
            }, this.error, {});
        }
        catch (e) {
            this.error(e);
        }
    }
    /**
     * @function clearWatch: Will stop the watcher of the position
     * @returns void
     */
    clearWatch() {
        try {
            this.navigator.clearWatch(this.positionWatcher);
            this.positionWatcher = {};
        }
        catch (e) {
            this.error(e);
        }
    }
    /**
     * @porperty position: Set the position of the vehicle when it's invoked by
     * watchPosition or currentPosition
     * @returns void
     */
    position(position) {
        this.positionResult = position;
    }
    /**
     * @function error: Will throw a JS error if watchPosition or currentPosition execute
     * error callback
     * @returns void
     */
    error(e) {
        throw ({
            error: e.code ? e.code : e,
        });
    }
}
exports.default = Geolocation;
//# sourceMappingURL=Geolocation.js.map